<template>
  <component :is="wrapper" class="pt-2">
    <ReactiveDynamicForm
      v-if="showForm"
      ref="rdForm"
      :key="crudFormUpdates"
      v-model="formValue"
      :initial-value="initialValue"
      :use-tabbed-view="form.useTabbedView || false"
      :tabs-headers="form.tabsHeaders || null"
      :schema="form.schema"
      :entity-id="entityId"
      :entry-id="entryId"
      :show-navigation-buttons="false"
      @onFormUpdate="updateFormValue"
      @refreshRequested="handleRefreshRequest"
      @refreshFormRequested="handleRefreshFormRequest"
    ></ReactiveDynamicForm>
    <!-- :autoHandleRefreshRequests="false" -->
    <v-progress-circular
      v-else
      justify-end
      justify-center
      :size="30"
      color="primary"
      indeterminate
    ></v-progress-circular>
    <v-layout v-if="showForm && showUpdateBtn" row wrap>
      <v-btn
        :disabled="loading"
        :color="getButtonColor('update') || '#efca31'"
        class="update-button"
        @click="update"
      >
        <v-icon v-if="getButtonIcon('update') != null" left>{{
          getButtonIcon('update')
        }}</v-icon
        >{{ updateBtnLabel }}</v-btn
      >

      <v-btn
        :disabled="loading"
        :color="getButtonColor('delete') || '#FF6C00'"
        :class="getButtonClass('delete')"
        @click="remove"
      >
        <v-icon v-if="getButtonIcon('delete') != null" left>{{
          getButtonIcon('delete')
        }}</v-icon
        >{{ deleteBtnLabel }}</v-btn
      >
      <!-- <v-flex v-for="(btn, key) in customActions" :key="key"> -->
      <v-btn
        v-for="(btn, key) in customActions"
        :key="key"
        :color="btn.color"
        :class="btn.class"
        :disabled="loadingBtnKey != null && loadingBtnKey !== key"
        :loading="loadingBtnKey === key"
        @click="
          loadingBtnKey = key
          executeFunction(btn.functionName)
        "
      >
        <v-icon v-if="btn.icon != null && typeof btn.icon === 'string'" left>{{
          btn.icon
        }}</v-icon>
        <v-icon
          v-if="btn.icon != null && btn.icon.left && btn.icon.id != null"
          :dark="btn.icon.dark"
          left
          >{{ btn.icon.id }}</v-icon
        >{{ btn.label }}
        <v-icon
          v-if="btn.icon != null && btn.icon.right && btn.icon.id != null"
          :dark="btn.icon.dark"
          right
          >{{ btn.icon.id }}</v-icon
        >
      </v-btn>
      <!-- </v-flex> -->
      <v-spacer />
      <v-btn v-if="showNavigationButtons" icon @click="$refs.rdForm.prevTab()">
        <v-icon color="info">arrow_back</v-icon>
      </v-btn>
      <v-btn v-if="showNavigationButtons" icon @click="$refs.rdForm.nextTab()">
        <v-icon color="info">arrow_forward</v-icon>
      </v-btn>
    </v-layout>
    <v-layout v-else row wrap>
      <v-btn
        v-if="showForm && showAddBtn"
        :color="getButtonColor('add') || '#efca31'"
        :class="getButtonClass('add')"
        @click="add"
      >
        <v-icon v-if="getButtonIcon('add') != null" left>{{
          getButtonIcon('add')
        }}</v-icon>
        {{ addBtnLabel }}</v-btn
      >
      <v-btn
        v-if="showForm && showDeleteBtn"
        :color="getButtonColor('delete') || 'red'"
        :class="getButtonClass('delete')"
        @click="remove"
      >
        <v-icon v-if="getButtonIcon('delete') != null" left>{{
          getButtonIcon('delete')
        }}</v-icon>
        {{ deleteBtnLabel }}</v-btn
      >
      <v-btn
        v-if="showForm && showUpdateBtn"
        :color="getButtonColor('update') || 'primary'"
        :class="getButtonClass('update')"
        @click="update"
      >
        <v-icon v-if="getButtonIcon('update') != null" left>{{
          getButtonIcon('update')
        }}</v-icon>
        {{ updateBtnLabel }}</v-btn
      >
      <v-spacer />
      <v-btn v-if="showNavigationButtons" icon @click="$refs.rdForm.prevTab()">
        <v-icon color="info">arrow_back</v-icon>
      </v-btn>
      <v-btn v-if="showNavigationButtons" icon @click="$refs.rdForm.nextTab()">
        <v-icon color="info">arrow_forward</v-icon>
      </v-btn>
    </v-layout>
  </component>
</template>

<script>
import ApiService from '../APIService'
import CrudModes from '../CrudModes'
import { removeWidgetsForAddMode } from '../utils/schema-utils.js'

export default {
  name: 'CrudForm',
  components: {
    ReactiveDynamicForm: () => import('../ReactiveDynamicForm')
  },
  props: {
    entityId: {
      type: String,
      required: true
    },
    entryId: {
      type: String,
      required: false,
      default: null
    },
    schemaAdjustments: {
      // used to configure the form: hide fields, set initial values
      type: Object,
      required: false,
      default: null
    },
    refMode: {
      type: Boolean,
      default: false
    },
    readOnlyMode: {
      type: Boolean,
      default: false
    },
    crudFormRedirect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: 0,
      formValue: {},
      form: null,
      initialValue: {},
      crudFormUpdates: 0,
      test: {},
      tabbedFormValid: {},
      isFormValid: false,
      addBtnClicked: 0,
      loadingBtnKey: null,
      title: null
    }
  },
  computed: {
    loading() {
      return this.loadingBtnKey != null
    },
    customActions() {
      return this.form != null && this.form.customizations != null
        ? this.form.customizations.customActions
        : null
    },
    buttonsStyles() {
      return this.form != null && this.form.customizations != null
        ? this.form.customizations.buttonsStyles
        : null
    },
    addBtnLabel() {
      return this.buttonsStyles != null &&
        this.buttonsStyles.add != null &&
        this.buttonsStyles.add.label != null &&
        this.buttonsStyles.add.label !== ''
        ? this.buttonsStyles.add.label
        : 'Adaugă'
    },
    updateBtnLabel() {
      return this.buttonsStyles != null &&
        this.buttonsStyles.update != null &&
        this.buttonsStyles.update.label != null &&
        this.buttonsStyles.update.label !== ''
        ? this.buttonsStyles.update.label
        : 'Salvează'
    },
    deleteBtnLabel() {
      return this.buttonsStyles != null &&
        this.buttonsStyles.delete != null &&
        this.buttonsStyles.delete.label != null &&
        this.buttonsStyles.delete.label !== ''
        ? this.buttonsStyles.delete.label
        : 'Șterge'
    },
    showNavigationButtons() {
      return (
        this.form &&
        this.form.useTabbedView &&
        this.opMode !== CrudModes.TYPES.READ
      )
    },
    wrapper() {
      if (this.opMode === CrudModes.TYPES.READ) {
        return 'div'
      } else {
        return 'v-card'
      }
    },
    opMode: function() {
      return this.readOnlyMode || this.refMode
        ? CrudModes.TYPES.READ
        : this.entryId != null
        ? CrudModes.TYPES.UPDATE
        : CrudModes.TYPES.ADD
    },
    showAddBtn: function() {
      return (
        this.opMode === CrudModes.TYPES.ADD ||
        this.opMode === CrudModes.TYPES.CHILD_ENTITY
      )
    },
    showDeleteBtn: function() {
      return this.opMode === CrudModes.TYPES.UPDATE
    },
    showUpdateBtn: function() {
      return this.showDeleteBtn
    },
    showForm: function() {
      return this.form != null
      // return (
      //   (this.opMode === CrudModes.TYPES.ADD && this.form != null) ||
      //   this.opMode === CrudModes.TYPES.CHILD_ENTITY ||
      //   this.opmode === CrudModes.TYPES.UPDATE ||
      //   (this.opMode === CrudModes.TYPES.READ && this.form != null)
      // );
      // nu functioneaza ok cand avem un computed property care depinde de un altul
    }
  },
  watch: {
    title: function() {
      this.$emit('getTitleCrudForm', this.title) //send title up for breadcrumb
    }
  },
  created() {
    if (this.form == null) {
      ApiService.getForm(this.entityId, this.refMode === false ? 'crud' : 'ref')
        .then((res) => {
          let result = res.data
          console.log(result)
          this.title = result.title
          this.refMode && this.doubleRef(result.schema)
          this.refMode && this.makeSchemaReadOnly(result.schema)
          // this.opMode !== CrudModes.TYPES.UPDATE &&
          //   this.hideWidgets(res.data.schema, ["attachment", "pdfGenerator"]);
          this.adjustSchema(result.schema)
          if (this.opMode === CrudModes.TYPES.ADD) {
            try {
              result = {
                ...result,
                ...this.removeUselessFields({
                  schema: result.schema,
                  tabs: result.tabsHeaders
                })
              }
            } catch (err) {
              console.log('Could not remove useless fields')
              console.log(err)
            }
          }

          this.refMode && this.removeRequiredProp(result.schema)

          let tempForm = result
          for (var x in tempForm.schema) {
            if (tempForm.schema[x].initialValue !== undefined)
              this.formValue[x] = tempForm.schema[x].initialValue
          }

          // console.log("%cFetched crud form data", "color: #0c0");
          if (this.entryId != null) {
            ApiService.getEntry(this.entityId, this.entryId)
              .then((res) => {
                this.initialValue = res.data
                this.formValue = res.data
                this.processSchemaHardFilters(tempForm.schema)
                this.form = tempForm
                this.crudFormUpdates++
              })
              .catch(() => {})
          } else {
            this.form = tempForm
          }
        })
        .catch((error) => {
          console.log(
            'Error fetching crud form for CrudForm.vue: ' +
              JSON.stringify(error)
          )
        })
    }
  },
  destroyed() {
    this.$emit('destroyedCrudForm')
  },
  methods: {
    add() {
      this.addBtnClicked++
      if (this.$refs.rdForm.validateForm()) {
        if (JSON.stringify(this.formValue) !== JSON.stringify({})) {
          ApiService.createEntry(this.entityId, this.formValue)
            .then((res) => {
              this.$notify({
                group: 'notifications',
                type: 'success',
                title: 'Success',
                text: 'Entitatea s-a adaugat'
              })
              this.formValue._id = res.data
              this.$emit('entryAdded', res.data)

              if (
                this.opMode === CrudModes.TYPES.ADD &&
                this.crudFormRedirect === false
              ) {
                this.$router.push({
                  name: 'UpdateForm',
                  params: {
                    entityId: this.entityId,
                    entryId: this.formValue._id,
                    formType: 'crud'
                  }
                })
              }
            })
            .catch((ex) => {
              if (
                ex.response.status === 400 &&
                ex.response.data.exceptionType != null &&
                ex.response.data.exceptionType === 'unique-validation'
              ) {
                this.handleUniqueConstraintsValidationException(ex)
              } else if (
                ex.response.data.status === 401 ||
                ex.response.data.status === 403
              ) {
                this.$notify({
                  group: 'notifications',
                  type: 'error',
                  title: 'Eroare',
                  text: 'Nu sunteti autorizat sa efectuati aceasta actiune!'
                })
              }
            })
        }
      }
    },
    update() {
      if (this.$refs.rdForm.validateForm()) {
        if (this.formValue !== null) {
          if (
            confirm('Sunteti sigur ca vreti sa continuati aceasta operatiune?')
          ) {
            ApiService.updateEntry(
              this.entityId,
              this.formValue._id,
              this.formValue
            )
              .then(() => {
                this.$notify({
                  group: 'notifications',
                  type: 'success',
                  title: 'UPDATE',
                  text: 'Intrarea a fost actualizata cu success!'
                })
                // reload the current page
                this.$router.go()
              })
              .catch((ex) => {
                console.log('exception on update')
                console.log(ex.response)
                if (
                  ex.response.status === 400 &&
                  ex.response.data.exceptionType != null &&
                  ex.response.data.exceptionType === 'unique-validation'
                ) {
                  // unique validation failed
                  this.handleUniqueConstraintsValidationException(ex)
                }
              })
          }
        }
      }
    },
    remove() {
      if (this.formValue._id !== null) {
        if (
          confirm('Sunteti sigur ca vreti sa continuati aceasta operatiune?')
        ) {
          ApiService.deleteEntry(this.entityId, this.formValue._id).then(
            (res) => {
              if (res.response && res.response.status === 401) {
                this.$notify({
                  group: 'notifications',
                  type: 'error',
                  title: 'Eroare',
                  text: 'Nu sunteti autorizat sa efectuati aceasta actiune!'
                })
              } else if (res.status >= 200 && res.status <= 299) {
                this.$notify({
                  group: 'notifications',
                  type: 'error',
                  title: 'DELETE',
                  text: 'Entitatea s-a sters'
                })
                this.$emit('entryDeleted', this.formValue._id)
              }
            }
          )
        }
      }
    },
    updateFormValue: function(newVal, key) {
      this.formValue[key] = newVal
    },
    makeSchemaReadOnly: function(schema) {
      Object.keys(schema).forEach((key) => {
        schema[key].readonly = true
      })
    },
    doubleRef: function(schema) {
      Object.keys(schema).forEach((key) => {
        if (schema[key].type === 'ref') {
          schema[key].showButtons = false
          // hide v-card in v-card
          schema[key].dismissCardView = true
        }
      })
    },
    adjustSchema: function(schema) {
      if (this.schemaAdjustments == null) return
      Object.keys(this.schemaAdjustments).forEach((key) => {
        if (schema.hasOwnProperty(key)) {
          if (this.schemaAdjustments[key].hidden) {
            schema[key].hidden = true
          }
          if (this.schemaAdjustments[key].initialValue != null) {
            //this.initialValue[key] = this.schemaAdjustments[key].initialValue;
            // ar trebui sa configuram ReactiveDynamicForm cu v-model pentru a nu mai trebuie acest pas
            this.formValue[key] = this.schemaAdjustments[key].initialValue
          }
        }
      })
    },
    /**
     * Will delete the widgets from the schema
     * @param tabs - If tabs is specified will remove the tabs that remain empty after deleting widgets
     */
    removeUselessFields({ schema, tabs }) {
      removeWidgetsForAddMode({ schema, tabs })
    },

    removeRequiredProp(schema) {
      Object.keys(schema).forEach((key) => {
        if (schema[key].required === true) schema[key].required = false
        if (schema[key].rules != null) schema[key].rules = null
      })
    },
    /**
     * Checks each hard filter for form variables ($this.birthYear) and processes the filter's template with current form values.
     */
    processSchemaHardFilters(schema) {
      Object.keys(schema).forEach((key) => {
        if (schema[key].hasOwnProperty('hardFilters')) {
          if (
            !schema[key].hardFilters.hasOwnProperty('initialBody') &&
            schema[key].hardFilters.hasOwnProperty('body')
          ) {
            schema[key].hardFilters.initialBody = JSON.parse(
              JSON.stringify(schema[key].hardFilters.body)
            )
          }
          schema[key].hardFilters.body = this.processHardFilterMember(
            schema[key].hardFilters.initialBody
          )
        }
      })
    },
    /**
     * Recursive function that processes the template, replacing variables identifiers with their values.
     * Ex: replaces "$this.birthYear" with 2005.
     */
    processHardFilterMember(template) {
      var target = {}
      Object.keys(template).forEach((key) => {
        if (
          typeof template[key] === 'string' &&
          template[key].startsWith('$this.')
        ) {
          let entryKey = template[key].replace('$this.', '')
          try {
            // var entryCopy = Object.assign({}, currentEntry);
            var filterValue = this.getObjectProperty(this.formValue, entryKey)
            // obj[key] = filterValue;
            target[key] = filterValue
          } catch (ex) {
            console.log(ex)
          }
        } else {
          if (template[key] instanceof Array) {
            target[key] = []
            template[key].forEach((el) => {
              target[key].push(this.processHardFilterMember(el))
            })
          } else if (
            typeof template[key] === 'object' &&
            template[key] !== null
          ) {
            target[key] = this.processHardFilterMember(template[key])
          } else {
            target = template
          }
        }
      })
      return target
    },
    /**
     * Extracts an object's property value based on the property path.
     * @param {Object} obj - The object.
     * @param {string} prop - The path of the property.
     * @returns {Any} value - The value found at obj[prop]
     */
    getObjectProperty(obj, prop) {
      // returns an object property based on the path given as string
      if (obj == null) return null
      if (obj[prop]) return obj[prop]

      var parts = prop.split('.')
      // TODO: Aici parts ar trebui sa aiba minim 2 elemente ca algoritmul sa mearga
      if (Array.isArray(parts)) {
        var last = parts.pop(),
          l = parts.length,
          i = 1,
          current = parts[0] || last

        while ((obj = obj[current]) && i < l) {
          current = parts[i]
          i++
        }
        if (obj) {
          return obj[last]
        }
      } else {
        throw 'parts is not valid array'
      }
    },
    /**
     * Handles refresh requests to be able to execute tasks before the refresh happens.
     * Invoker widget and invoker.
     * @param {string} targetWidget - The widget to be updated.
     */
    handleRefreshRequest() {
      this.processSchemaHardFilters(this.form.schema)
    },
    handleRefreshFormRequest() {
      ApiService.getEntry(this.entityId, this.entryId).then((res) => {
        if (res.status >= 200 && res.status <= 299) {
          this.formValue = res.data
          this.initialValue = res.data
          this.crudFormUpdates++
        }
      })
    },
    handleUniqueConstraintsValidationException(ex) {
      // unique validation failed
      console.log('add exception: ')
      console.log(JSON.stringify(ex.response.data))
      if (
        ex.response.data.exceptionMessage != null &&
        ex.response.data.exceptionMessage !== ''
      ) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Eroare',
          text: ex.response.data.exceptionMessage
        })
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Eroare',
          text:
            'Exista deja o intrare cu aceasta valoare pentru campul: ' +
            ex.response.data.field
        })
      }
    },
    executeFunction(functionName) {
      if (functionName == null || functionName === '') {
        this.loadingBtnKey = null
        return
      }
      console.log('Executing function: ' + functionName)

      ApiService.getFunctionValue(
        this.entityId,
        this.entryId,
        functionName,
        null
      )
        .then(() => {
          this.loadingBtnKey = null
          console.log(
            `%cFunction ${functionName} executed successfully`,
            'color: #0c0'
          )
          this.$router.go()
        })
        .catch((ex) => {
          this.loadingBtnKey = null
          console.log(
            '%cCould not execute function: ' + ex.response,
            'color: #f00'
          )
        })
    },
    getButtonColor(btnKey) {
      return this.buttonsStyles != null &&
        this.buttonsStyles[btnKey] != null &&
        this.buttonsStyles[btnKey].color != null
        ? this.buttonsStyles[btnKey].color
        : null
    },
    getButtonClass(btnKey) {
      return this.buttonsStyles != null &&
        this.buttonsStyles[btnKey] != null &&
        this.buttonsStyles[btnKey].class != null
        ? this.buttonsStyles[btnKey].class
        : null
    },
    getButtonIcon(btnKey) {
      return this.buttonsStyles != null &&
        this.buttonsStyles[btnKey] != null &&
        this.buttonsStyles[btnKey].icon != null
        ? this.buttonsStyles[btnKey].icon
        : null
    }
  }
}
</script>

<style>
.update-button {
  margin-left: 25px;
  margin-bottom: 2%;
}
</style>
